export default class BleClienNotInitializedError extends Error {
    constructor(message = '', ...args) {
        super(message, ...args);
        this.message = 'Client is not initialized, please create instance before using';
    }
}
